import React from 'react'
import { Head } from 'react-static'

// changes here requires dev server to restart
// because this component is used in the site config `static.config.js`

const LOGO = 'https://inten.to/img/brain.png'
const DESCRIPTION =
    'Discover, evaluate and use best-of-breed AI. A simple and elegant API to third-party AI models from many vendors.'
const TITLE = 'Intento'

const DEFAULT_TAGS = {
    title: TITLE,
    description: DESCRIPTION,
    logo: LOGO,
    author: 'Intento Inc.',
    twitter: {
        title: TITLE,
        description: DESCRIPTION,
        image: LOGO,
    },
    og: {
        title: TITLE,
        site_name: TITLE,
        description: DESCRIPTION,
        image: LOGO,
        imageHeight: 300,
        imageWidth: 300,
        url: 'https://inten.to/',
    },
}

const MetaTags = props => {
    const { tags = DEFAULT_TAGS } = props
    const meta = {
        ...DEFAULT_TAGS,
        ...tags,
        description: `${tags.description || ''} — ${DESCRIPTION}`,
        twitter: {
            ...DEFAULT_TAGS.twitter,
            ...tags.twitter,
            description: `${
                (tags.twitter || {}).description || ''
            } — ${DESCRIPTION}`,
        },
        og: {
            ...DEFAULT_TAGS.og,
            ...tags.og,
            description: `${
                (tags.og || {}).description || ''
            } — ${DESCRIPTION}`,
        },
    }

    return (
        <Head>
            {/* Search engines stuff */}
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta name="author" content={meta.author} />

            {/* FB stuff */}

            <meta property="og:type" content="website" />
            <meta property="og:title" content={meta.og.title} />
            <meta property="og:site_name" content={meta.og.site_name} />
            <meta property="og:url" content={meta.og.url} />
            <meta property="og:description" content={meta.og.description} />
            <meta property="og:image" content={meta.og.image} />
            <meta property="og:image:height" content={meta.og.imageHeight} />
            <meta property="og:image:width" content={meta.og.imageWidth} />

            {/* Twitter stuff */}

            <meta name="twitter:card" content="summary" />
            {/* <meta name="twitter:site" content="@intentonews" /> */}
            <meta name="twitter:title" content={meta.twitter.title} />
            <meta
                name="twitter:description"
                content={meta.twitter.description}
            />
            <meta name="twitter:image" content={meta.twitter.image} />
        </Head>
    )
}

export default MetaTags



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/MetaTags.jsx